// extracted by mini-css-extract-plugin
module.exports = {"edit-wrapper":"EditProfileUrl_edit-wrapper__oGRD8","url":"EditProfileUrl_url__A4yZQ","note":"EditProfileUrl_note__OuZwY","action-wrapper":"EditProfileUrl_action-wrapper__3k0vh"};